module.exports = __webpack_public_path__ + "img/23.0cc744b7.jpg";